import React, { Component, Suspense } from 'react'
import { translate } from 'react-i18next'
import Loader from '../Loader'
import FormInput from './FormInput'
import Upload from 'antd/lib/upload'
import Form from 'antd/lib/form'
import Icon from 'antd/lib/icon'
import SimpleBtn from '../SimpleBtn'
import firebase from 'firebase/app'
import 'firebase/storage'
import './index.sass'
class FormComponent extends Component {
  state = {
    name: '',
    company: '',
    phone: '',
    email: '',
    message: '',
    emailError: false,
    nameError: false,
    messageError: false,
    formValid: false,
    isFileFormatCorrect: true,
  }

  onHandleChange = e => {
    const { id, value } = e.target
    this.setState(
      {
        [e.target.id]: e.target.value,
      },
      () => this.onChangeCheckFormValid(id, value)
    )
  }

  checkEmailValid = email => {
    return !!email.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)
  }

  onChangeCheckFormValid = (id, value) => {
    if(id === 'name') {
      const errorFieldName = `${id}Error`
      this.setState({
        [errorFieldName]: Boolean(!value),
        formValid: Boolean(
          !this.state.nameError &&
            Boolean(this.state.name)
        ),
      })
    }
  }

  onChangeUpload = info => {
    this.setState(
      {
        file: info.file,
      },
      () => this.checkFileFormat()
    )
  }

  uploadFile = () => {
    const { file, name, company, email } = this.state
    const storageRef = firebase.storage().ref(`feedbacks/${name}-${company}-${email}-${file.name}`)
    return storageRef
      .put(file)
      .then(snapshot => snapshot.ref.getDownloadURL())
      .then(downloadURL => {
        console.log('file was sent')
        return downloadURL
      })
      .catch(err => console.error('Something went wrong' + err))
  }

  checkFileFormat = () => {
    const { file } = this.state
    this.setState({
      isFileFormatCorrect:
        file &&
        Boolean(
          file.name.match(
            /\.(doc|docx|xls|xlsx|txt|pdf|htm|html|rar|zip|wav|mp3|mp4|avi|mpg|wmv|gif|jpg|png|ttf)$/i
          )
        ) &&
        file.size / 1024 / 1024 <= 10,
    })
  }

  checkFormValid = () => {
    this.setState({
      nameError: Boolean(!this.state.name),
    })
  }

  onHandleRemoveFile = () => {
    this.setState({
      file: null,
      isFileFormatCorrect: true,
    })
  }

  handleSendFeedBack = async () => {
    const {
      createFeedBack,
      setChoosenVoice,
      choosenVoice,
      setContactLoadingStatus,
      clearContactLoadingStatus,
      setStatusMessage,
    } = this.props
    const { name, email, phone, company, message, file, isFileFormatCorrect, formValid } = this.state
    const data = { name, email, company, phone, message, choosenVoice }
    console.log(this.state)
    if (formValid && isFileFormatCorrect) {
      if (file) {
        let downloadURL
        try {
          setContactLoadingStatus()
          downloadURL = await this.uploadFile()
          clearContactLoadingStatus()
        } catch (e) {
          setStatusMessage('Something went wrong')
          clearContactLoadingStatus()
        }

        createFeedBack({ ...data, downloadURL, filename: file.name })
      } else {
        createFeedBack(data)
      }
      setChoosenVoice('')
    } else {
      this.checkFormValid()
    }
  }

  render = () => {
    const { nameError, emailError, messageError, isFileFormatCorrect, file } = this.state
    const { loadingStatus, choosenVoice, t, setChoosenVoice } = this.props
    return (
      <Suspense fallback={null}>
        <Form className="form" autoComplete='off'>
          {loadingStatus && (
            <div className="form-loader-wrapper">
              <Loader />
            </div>
          )}
          <FormInput
            label={t('form.name')}
            type="text"
            name="name"
            onHandleChange={this.onHandleChange}
            withError
            error={nameError}
          />
          <FormInput
            label={t('form.company')}
            type="text"
            name="company"
            onHandleChange={this.onHandleChange}
          />
          <FormInput
            label={t('form.phone')}
            type="text"
            name="phone"
            onHandleChange={this.onHandleChange}
          />
          <FormInput
            label={t('form.email')}
            type="email"
            name="email"
            onHandleChange={this.onHandleChange}
            withError
            error={emailError}
          />
          <FormInput
            label={t('form.message')}
            type="text"
            name="message"
            onHandleChange={this.onHandleChange}
            withError
            error={messageError}
            textarea
          />
          {choosenVoice && (
            <div className="choosen-voice">
              <span className="subtitle-2">{t('form.myChoice')}</span>
              <span className="subtitle-2">{choosenVoice}</span>
              <button className="btn btn-close" onClick={() => setChoosenVoice('')} />
            </div>
          )}
          <Upload
            name="file"
            action=""
            customRequest={this.onChangeUpload}
            onRemove={this.onHandleRemoveFile}
            multiple={false}
            fileList={file && [file]}
          >
            <div className="upload-text">
              <Icon type={'plus'} />
              <div className="ant-upload-text subtitle-2">{t('form.file')}</div>
            </div>
            <p className="caption">{t('form.fileRule')}</p>
            {file && !isFileFormatCorrect && <p className="caption error">{t('form.fileError')}</p>}
          </Upload>

          <SimpleBtn
            btnName={t('general.send')}
            border={true}
            onHandleClick={this.handleSendFeedBack}
          />
        </Form>
      </Suspense>
    )
  }
}

export default translate('translations')(Form.create()(FormComponent))
